import {MainPageItem} from "utils/interface/MainPage";
import {PaiPointButtonPropsInterface} from "utils/interface/ComponentsInterface";

export interface AdminSiderMenuItem {
    id: string
    type: 'static' | 'magicChart' | 'magicForm'
    parentId: string
    icon: number
    applicationName: string
    url: string
    magicId: string
    sort: string
}

export interface AdminSiderStoreInterface {
    adminSiderMenuList: AdminSiderMenuItem[]
    getAdminSiderMenuListLoading: boolean
}

export interface SystemInfoStoreInterface {
    userInfo: SystemUserInfoInterface
}

export interface SystemUserInfoInterface {
    name: string,
    group: string,
    businessId: string,
}

export enum PaiPointComponentsEnum {
    CONTAINER = 'container',
    LOGO = 'logo',
    MENU = 'menu',
    BOX = 'box',
    BUTTON = 'button',
    TEXT = 'text'
}

export interface PaiPointContainer {
    id: string,
    type: PaiPointComponentsEnum.CONTAINER,
    containerConfig: ContainerConfigInterface,
    items: MainPageItem[]
}

export interface PaiPointButtonContainerInterface {
    id: string,
    type: PaiPointComponentsEnum.BUTTON,
    containerConfig: ContainerConfigInterface,
    itemConfig: PaiPointButtonPropsInterface
}

export interface ContainerConfigInterface {
    paddingTop?: string
    paddingLeft?: string
    paddingRight?: string
    paddingBottom?: string
    marginTop?: string
    marginLeft?: string
    marginRight?: string
    marginBottom?: string
    justifyContent?: JustifyContentType
    alignItems?: alignItemsType,
    width?: string
    height?: string
    color?: string,
    fontSize?: string,
    fontWeight?: string,
    cursor?: string,
    backgroundColor?: string,
    flex?: flexType,
    flexWrap?: flexWrapType,
}

export type flexWrapType =
    'wrap' |
    'nowrap'

export type flexType =
    'none' |
    'auto' |
    'inherit' |
    'initial' |
    'revert' |
    'revert-layer' |
    'unset'

export type JustifyContentType =
    'start' |
    'end' |
    'center' |
    'space-around' |
    'space-between' |
    'space-evenly'

export type alignItemsType =
    'start' |
    'end' |
    'center'

export type CursorType =
    'pointer'

export interface RequestBodyInterface {
    code: string
    data: any
    msg?: string
}